import React from 'react';
import { AppSubscriptionCountry } from '../../../models/app';
import styles from './styles.module.scss';
import { PricingDetail } from './pricing-detail';
import ctx from 'classnames';


interface ComponentProps {
  subscriptionToShow: AppSubscriptionCountry;
  currentSubscription?: AppSubscriptionCountry;
  meteredBillingString?: string;
}


export const PricingInfo: React.FC<ComponentProps> = ({ subscriptionToShow, currentSubscription, meteredBillingString }): JSX.Element => {
  const { description, name, id, amount, country } = subscriptionToShow;
  const showCheckIcon = currentSubscription && currentSubscription.id === id;

  return (
    <>
      <div className={ctx(styles.subscriptionBox, {[styles.hasLeftCheckIcon]: showCheckIcon})}>
        {showCheckIcon && <i className={ ctx('fa', 'fa-check-circle', styles.icon, styles.checkIcon, styles.left)} aria-hidden="true" />}
        <PricingDetail name={name} description={description} amount={amount} country={country} meteredBillingString={meteredBillingString}/>
      </div>
    </>
  )
}
